import { useMemo } from 'react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchNavigationCustomization } from '../../api/portalGateway/navigationCustomization';
import { prependRoleId } from '../../utils/prependRoleId';

export function navigationCustomizationOptions() {
  return queryOptions({
    queryKey: prependRoleId(['navigationCustomization']),
    queryFn: fetchNavigationCustomization,
  });
}

export function useNavigationCustomizationQuery() {
  return useQuery(navigationCustomizationOptions());
}

export const useGetDynamicNavData = () => {
  const { data, isPending } = useQuery(navigationCustomizationOptions());

  return useMemo(() => {
    if (!data?.data?.dynamicNavigationItems) {
      return { isPending, navItems: [] };
    }

    const navItems = data.data.dynamicNavigationItems.map((item) => ({
      ...item,
      completeSlug: item.href,
      iconName: item.icon,
    }));

    return { isPending, navItems };
  }, [data, isPending]);
};
